export default __webpack_public_path__ + "static/media/naming ceremony header.ec3fe4d9.jpg";